import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseAuthComponent } from '../../abstract-components/base-auth.component';

@Component({
  selector: 'ntd',
  standalone: false,
  templateUrl: './ntd.component.html',
  styleUrl: './ntd.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NtdComponent extends BaseAuthComponent {
  title = 'Votre compte est lié à plusieurs entreprises';
  description =
    'Veuillez renseigner le champs ci-dessous pour accéder à votre espace.';
}
